import React, { useEffect, useState } from 'react';

import { Row, Container, Col } from 'react-bootstrap';

import Image from '../../../core-components/Image';
import { isMobileTablet, jwtParser } from '../../../utils/utilities';

import styles from './BgvHeader.module.scss';

export default (props) => {
  const token = new URLSearchParams(document.location.search).get('token') || null;
  const parsedJwtDetail = jwtParser(token);
  return (
    <Container fluid className={styles.bgvHeaderContainer}>
      <Row className={styles.bgvHeader}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <Container className={styles.bgvHeaderItem}>
            <div className={styles.headerItemLeft}>
              <Image name='sv_logo_desktop.svg' />
              <span>BGV for {parsedJwtDetail?.data?.companyName}</span>
            </div>
          </Container>
        </Col>
      </Row>
    </Container>
  );
};
